import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SchoolIcon from '@mui/icons-material/School';
import MovingIcon from '@mui/icons-material/Moving';
import { Typography } from '@mui/material';
import { BASE_URL } from "../../utils/config";
import { useUser } from "../../context/UserContext";

function LeadershipRank() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [pmallUser, setPmallUser] = useState([]);

  const getUsersDetails = () => {
    // setLoading(true);
    const isPrivilegedUser = ["Admin", "Vendor", "Affiliate"].includes(user?.accountType);
    const endpoint = isPrivilegedUser ? "profile" : "customer/profile";
    fetch(`${BASE_URL}/${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + user?.token,
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        if (result.status) {
          const profileData = result?.data?.user || result?.customer;
          console.log(profileData);
          setPmallUser(profileData);
        } else {
          console.warn("Failed to fetch user details:", result.message);
        }
      })
      .catch((err) => {
        console.error("Error fetching user details:", err);
      })
      .finally(() => {
        // setLoading(false);
      });
  };


  const determineRank = (currentPv) => {
    let rank = 'Influencer';
    if (currentPv >= 1000000) {
      rank = 'Ambassador';
    } else if (currentPv >= 500000) {
      rank = 'Diamond Director';
    } else if (currentPv >= 250000) {
      rank = 'Director';
    } else if (currentPv >= 100000) {
      rank = 'Elite Manager';
    } else if (currentPv >= 60000) {
      rank = 'Manager';
    } else if (currentPv >= 25000) {
      rank = 'Influencer';
    }
  
    return rank;
  };
  
    
useEffect(()=> {
  let isLoggedIn = localStorage.getItem("authToken");
    if (!isLoggedIn) {
      navigate("/");
    }
    getUsersDetails();
}, [])
  return (
    <>
    <div className="flex flex-col gap-5 bg-white p-5 rounded-lg shadow-md" style={{ padding: 60}}>
            <div className="w-full flex justify-between items-center">
                <div className="space-y-2">
                    <h1 className="text-xl font-bold mt-lg">Leadership Ranks</h1>
                </div>
            </div>

        <div className="flex mt-10 adsfjyeee" style={{justifyContent: "space-evenly"}}>
        <div className="">
          <div className="" style={{fontSize: 20}}>
            <>
            Pont Value Earned
            </>
            </div> &nbsp; &nbsp;
          {/* <div className="">Point Value</div> */}

          <div className="bold" style={{fontSize: 40}}>
            <>
            {pmallUser?.wallet?.pv}
            </>
            </div> &nbsp; &nbsp;
          <div className="mt-n10">Point Value</div>
        </div>
        <div className="flex">
          <div className="flex label">
            <>
           -
            </>
          </div>&nbsp; &nbsp;
          {/* <div className=" c-success">{determineRank(pmallUser?.wallet?.pv)}</div> */}
        </div>
        <div className="">
          <div className="" style={{fontSize: 20}}>
           
            </div> &nbsp; &nbsp;

          <div className="bold" style={{fontSize: 40}}>
            <>
            {determineRank(pmallUser?.wallet?.pv)}
            </>
            </div> &nbsp; &nbsp;
          <div className="mt-n10">Current Rank</div>
        </div>
      </div>

      <h3 className="uppercase c-red mt-10 mx-md">Qualifying Stages</h3>
          <div className="row">
            {/* <div className="cell uppercase bold">S/N</div> */}
            <div className="cell uppercase bold">Stage</div>
            <div className="cell uppercase bold">How to Qualify</div>
            <div className="cell uppercase bold">Incentive</div>
          </div>
          <div className="row">
          {/* <div className="cell">1</div> */}
          <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color"> ♟ </Typography>
            <p className="ml-10">Influencer</p>
            </div>
          </div>
            <div className="cell">25,000 Point Values (PVs)</div>
            
            <div className="cell">2 Million Naira in Cash</div>
            
          </div>
          <div className="row">
          {/* <div className="cell">2</div> */}
            <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color">♞</Typography>
            <p className="ml-10">Manager</p>
            </div>
            </div>
            <div className="cell">60,000 Point Values(PVs)</div>
            
            <div className="cell">
              4 Million Naira in Cash
            </div>
            
          </div>
          <div className="row">
          {/* <div className="cell">3</div> */}
            <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color">♝</Typography>
            <p className="ml-10">Elite Manager</p>
            </div>
            </div>
            <div className="cell">100,000 Point Values (PVs)</div>
            <div className="cell">
              7 Million Naira in Cash + 2 Million Naira Int'l Trip
            </div>
            
          </div>
          <div className="row">
            {/* <div className="cell">4</div> */}
            <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color">♜</Typography>
            <p className="ml-10">Director</p>
            </div>
            </div>
            <div className="cell">250,000 Point Values (PVs)</div>
            <div className="cell">
              10 Million Naira in Cash + Any Saloon Car
            </div>
          </div>
          <div className="row">
            {/* <div className="cell">5</div> */}
            <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color">♛</Typography>
            <p className="ml-10">Diamond Director</p>
            </div>
            </div>
            <div className="cell">500,000 Point Values (PVs)</div>
            <div className="cell">
              40 Million Naira in Cash
            </div>
          </div>
          <div className="row">
            {/* <div className="cell">6</div> */}
            <div className="cell">
            <div className="flex alc">
            <Typography variant="h4" className="grey-color">♚</Typography>
            <p className="ml-10">Ambassador</p>
            </div>
            </div>
            <div className="cell">1,000,000 Point Values (PVs)</div>
            <div className="cell">
              70 Million Naira in Cash
            </div>
          </div>
          <h3 className="mt-10 text-center" style={{marginTop: '5%'}}>Note:  40 : 40 : 20    Balancing is required for all qualification <a className="c-red"> What is this? </a></h3>

      </div>

        </>
  )
}

export default LeadershipRank